import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = ['acquisitionSurveyShown', 'acquisitionSurveySubmitted', 'acquisitionSurveySkipped'] as const;

export const acquisitionSurveyEvents = getMappedEvents([...EVENTS], { shouldSendSubscriptionData: true });
